(() => {
  const preferenceKey = 'satanama_language_preference';
  const attemptedKey = 'satanama_language_detection_done';
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  document.querySelectorAll('.satanama-language-switcher form').forEach(form => {
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    form.addEventListener('submit', event => {
      const selected = event.submitter;
      if (selected && selected.name === 'language_code') write(preferenceKey, selected.value);
    });
  });
  const current = document.documentElement.lang.split('-')[0];
  const browser = (navigator.language || '').split('-')[0].toLowerCase();
  const preference = read(preferenceKey);
  const params = new URLSearchParams(location.search);
  if (window.Shopify && window.Shopify.designMode) return;
  if (params.has('locale') || params.has('_locale')) return;
  if (current !== 'ja') return;
  if (/^\/(cart|account|checkout|checkouts|admin)(\/|$)/.test(location.pathname)) return;
  if (preference === 'ja' || read(attemptedKey)) return;
  if (preference !== 'en' && browser !== 'en') return;
  const button = document.querySelector('.satanama-language-switcher button[value="en"]');
  if (!button) return;
  write(attemptedKey, '1');
  button.form.requestSubmit(button);
})();
